import React from 'react';
// Note: If you don't have lucide-react, you can replace <ArrowRight /> with a standard →
import { ArrowRight, FileText, UserCheck, Globe, Upload, ShieldCheck, TrendingUp, Briefcase } from 'lucide-react';

/**
 * 1. CONFIGURATION DATA
 * Update this array to change the content on the website.
 */
const SERVICES_DATA = [
    {
        id: 1,
        title: "File ITR Yourself (DIY filing)",
        description: "Trust us; you can file income tax return on your own. It's fast, easy, and safe.",
        cta: "Start Filing",
        isFeatured: true, // This makes it the large blue card
        icon: null,
    },
    {
        id: 2,
        title: "Expert Assisted ITR Filing",
        description: "Hire personal eCA to do Income Tax Filing for you. It is convenient & fast, with maximum refund calculated for you.",
        cta: "Book eCA Today",
        isFeatured: false,
        icon: <UserCheck className="text-green-600" size={32} />,
    },
    {
        id: 3,
        title: "Updated Return Filing (ITR-U)",
        description: "ITR-U helps individuals to update the correct income in the already filed ITR and also provides an opportunity for those who haven't filed previously.",
        cta: "File Now",
        isFeatured: false,
        icon: <FileText className="text-green-600" size={32} />,
    },
    {
        id: 4,
        title: "Capital Gain Tax Filing",
        description: "Seeking tax expert advice on the transaction done with respect to the sale of property, equity shares, mutual fund units, or bonds.",
        cta: "Connect Today",
        isFeatured: false,
        icon: <TrendingUp className="text-green-600" size={32} />,
    },
    {
        id: 5,
        title: "Futures & Options (F&O) Trading",
        description: "If you trade in Futures & Options (F&O), your income is treated as business income and must be reported while filing ITR.",
        cta: "F&O Trading Service",
        isFeatured: false,
        icon: <Briefcase className="text-green-600" size={32} />,
    },
    {
        id: 6,
        title: "NRI Tax Filing",
        description: "Ease your Indian tax filing with our experts, covering both foreign and domestic income. Our online CA ensures accuracy.",
        cta: "File Now",
        isFeatured: false,
        icon: <Globe className="text-green-600" size={32} />,
    },
    {
        id: 7,
        title: "Upload Form 16",
        description: "Simplify the Income Tax Return filing process. Just upload your Form 16 and get the ITR prepared automatically.",
        cta: "Upload Now",
        isFeatured: false,
        icon: <Upload className="text-green-600" size={32} />,
    },
    {
        id: 8,
        title: "Tax Planning Services",
        description: "Maximize tax savings with Tax Advisory Services, offering guidance on investments and deductions.",
        cta: "Consult Now",
        isFeatured: false,
        icon: <ShieldCheck className="text-green-600" size={32} />,
    },
];

/**
 * 2. SUB-COMPONENT: INDIVIDUAL CARD
 */
const ServiceCard = ({ service }) => {
    const { title, description, cta, isFeatured, icon } = service;

    // Featured Card (Blue) vs Regular Card (White) logic
    const containerStyles = isFeatured
        ? "bg-[#5D87B8] text-white md:col-span-2 p-10 ring-1 ring-blue-400"
        : "bg-white text-[#1A2B3C] p-8 border border-gray-100 hover:shadow-md transition-shadow";

    const titleStyles = isFeatured ? "text-3xl font-bold" : "text-xl font-bold";
    const descStyles = isFeatured ? "text-blue-50 opacity-90" : "text-gray-500";

    const buttonStyles = isFeatured
        ? "bg-white text-[#5D87B8] px-8 py-3 rounded-full font-bold flex items-center gap-2 hover:bg-blue-50 transition-colors w-fit"
        : "text-green-600 font-bold flex items-center gap-2 hover:gap-3 transition-all w-fit";

    return (
        <div className={`rounded-3xl flex flex-col justify-between gap-6 ${containerStyles}`}>
            <div>
                {icon && <div className="mb-4">{icon}</div>}
                <h3 className={`${titleStyles} mb-3 leading-tight`}>{title}</h3>
                <p className={`${descStyles} text-sm leading-relaxed max-w-md`}>
                    {description}
                </p>
            </div>

            <button className={buttonStyles}>
                {cta} <ArrowRight size={18} />
            </button>
        </div>
    );
};

/**
 * 3. MAIN COMPONENT
 */
const ServicesSection = () => {
    return (
        <section className="bg-[#F8FAFC] py-20 px-6">
            <div className="max-w-7xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-16">
                    <span className="text-xs font-bold uppercase tracking-[0.2em] text-gray-400 block mb-3">
                        Popular Services
                    </span>
                    <h2 className="text-4xl md:text-5xl font-black text-[#1A2B3C]">
                        Income Tax and GST Services We Offer
                    </h2>
                </div>

                {/* Bento Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {SERVICES_DATA.map((service) => (
                        <ServiceCard key={service.id} service={service} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;